import { DriveDateSelector } from '@/components/checkout/shipMode/DeliverySelector/DriveDateSelector';
import { useTranslation } from 'next-i18next';
import React, { useCallback } from 'react';
import DelayedShipping from '@/components/checkout/shipMode/DeliverySelector/DelayedShipping';
import WeatherHold from '@/components/checkout/shipMode/DeliverySelector/WeatherHold';
import WoodenCase from '@/components/checkout/shipMode/DeliverySelector/WoodenCase';
import TopChrono from '@/components/checkout/shipMode/DeliverySelector/TopChrono';
import TopChronoModal from '@/components/layout/modals/TopChronoModal';
import DeliverySchedule from '@/components/checkout/shipMode/DeliverySelector/DeliverySchedule';
import DeliveryScheduleModal from '@/components/layout/modals/DeliveryScheduleModal';
import { useAppSelector } from '@/redux';

export const ShippingContent = ({ shipping, onUpdate }: any) => {
  const { t } = useTranslation();
  const { topChronoVisible, deliveryScheduleVisible } = useAppSelector(({ gui }) => gui);

  const {
    _id,
    detail,
    longDesc,
    isDrive,
    isTopChrono,
    canBeDelayed,
    canBeBlocked,
    weatherHold,
    woodenCase,
    withWoodenCaseOption,
    isSchedulable,
    deliveryDates,
    isDayOnly
  } = shipping;

  const selectedSlot = useCallback((slot) => {
    const updatedShippingMode = {
      ...shipping,
      bookingSlot: undefined,
      pickUpLater: false,
      topChronoSlot: undefined
    };

    if (slot?.start && slot?.end) {
      updatedShippingMode.bookingSlot = slot;
    } else if (slot?.pickUpLater) {
      updatedShippingMode.pickUpLater = true;
    } else if (isTopChrono || isSchedulable) {
      updatedShippingMode.bookingSlot = slot;
    }

    onUpdate(updatedShippingMode);
  }, [shipping, onUpdate, isTopChrono, isSchedulable]);

  return (
    <>
      {detail ? (
        <div dangerouslySetInnerHTML={{ __html: detail }} />
      ) : (
        longDesc
      )}
      {canBeDelayed &&
        <DelayedShipping deliveryMode={shipping} isExproCheckout={false} />
      }
      {canBeBlocked && weatherHold &&
        <WeatherHold weatherHold={weatherHold} deliveryMode={shipping} isExproCheckout={false} />
      }
      {withWoodenCaseOption && Object.keys(woodenCase).length > 0 && (
        <WoodenCase woodenCase={woodenCase} deliveryMode={shipping} isExproCheckout={false} isSelected={true} />
      )}
      {isDrive && (
        <DriveDateSelector
          t={t}
          onChange={selectedSlot}
          shippingId={_id}
          className="shipmode-timeSlots tu-timeSlots"
          isExproCheckout={false}
        />
      )}
      {isTopChrono && (
        <>
          <TopChrono shippingId={shipping._id} isExproCheckout={false} />
          {topChronoVisible && (
            <TopChronoModal onSelectedSlot={selectedSlot} isExproCheckout={false} isOpen={topChronoVisible} />
          )}
        </>
      )}
      {isSchedulable && deliveryDates && (
        <>
          <DeliverySchedule shippingId={shipping._id} isExproCheckout={false} isDayOnly={isDayOnly} />
          {deliveryScheduleVisible && (
            <DeliveryScheduleModal
              data={deliveryDates}
              onSelectedSlot={selectedSlot}
              isExproCheckout={false}
              isOpen={deliveryScheduleVisible}
              isDayOnly={isDayOnly}
            />
          )}
        </>
      )}
    </>
  );
};

export default ShippingContent;
